import { get } from "./axios.js";

// 获取列表
export const GetList = (opts) => get("", opts);
